const GITHUB_API = 'https://api.github.com';

export async function exportToGitHub(token, repoOwner, repoName, branch, files, commitMessage) {
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: 'application/vnd.github+json',
    'Content-Type': 'application/json',
  };

  let baseSha = null;
  try {
    const res = await fetch(`${GITHUB_API}/repos/${repoOwner}/${repoName}/git/refs/heads/${branch}`, { headers });
    if (res.ok) {
      const ref = await res.json();
      baseSha = ref.object.sha;
    }
  } catch {
    // Branch might not exist
  }

  let treeSha = null;
  if (baseSha) {
    const commitRes = await fetch(`${GITHUB_API}/repos/${repoOwner}/${repoName}/git/commits/${baseSha}`, { headers });
    if (commitRes.ok) {
      const commit = await commitRes.json();
      treeSha = commit.tree.sha;
    }
  }

  const treeEntries = files.map((f) => ({
    path: f.path,
    mode: '100644',
    type: 'blob',
    content: f.content,
  }));

  const treeRes = await fetch(`${GITHUB_API}/repos/${repoOwner}/${repoName}/git/trees`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ base_tree: treeSha, tree: treeEntries }),
  });

  if (!treeRes.ok) {
    throw new Error(`Failed to create tree: ${treeRes.status}`);
  }
  const newTree = await treeRes.json();

  const commitBody = {
    message: commitMessage,
    tree: newTree.sha,
    parents: baseSha ? [baseSha] : [],
  };
  const commitRes = await fetch(`${GITHUB_API}/repos/${repoOwner}/${repoName}/git/commits`, {
    method: 'POST',
    headers,
    body: JSON.stringify(commitBody),
  });

  if (!commitRes.ok) {
    throw new Error(`Failed to create commit: ${commitRes.status}`);
  }
  const newCommit = await commitRes.json();

  const refRes = await fetch(`${GITHUB_API}/repos/${repoOwner}/${repoName}/git/refs/heads/${branch}`, {
    method: 'PATCH',
    headers,
    body: JSON.stringify({ sha: newCommit.sha }),
  });

  if (!refRes.ok) {
    const createRefRes = await fetch(`${GITHUB_API}/repos/${repoOwner}/${repoName}/git/refs`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ ref: `refs/heads/${branch}`, sha: newCommit.sha }),
    });
    if (!createRefRes.ok) {
      throw new Error(`Failed to create branch: ${createRefRes.status}`);
    }
  }

  return {
    sha: newCommit.sha,
    url: `https://github.com/${repoOwner}/${repoName}/tree/${branch}`,
  };
}

export function buildTerraformFiles(hcl, tfvars, variables) {
  const files = [{ path: 'main.tf', content: hcl }];
  if (variables) files.push({ path: 'variables.tf', content: variables });
  if (tfvars) files.push({ path: 'terraform.tfvars', content: tfvars });
  return files;
}
